<template>
  <div class="equipList">
    <div v-if="noData && equipList.length">
    <cus-title text="仪器样例"></cus-title>
    <div class="equip-search">
      <div class="search-left">
        <el-select
          v-model="subjectOptions"
          collapse-tags
          multiple
          clearable
          placeholder="请选择学科"
        >
          <el-option
            v-for="item in subjectList"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="gradeSectionOptions"
          collapse-tags
          multiple
          clearable
          placeholder="请选择学段"
        >
          <el-option
            v-for="item in gradeSectionList"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="useRefOptions"
          collapse-tags
          multiple
          clearable
          placeholder="请选择仪器使用参考属性"
        >
          <el-option
            v-for="item in useRefList"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId"
          >
          </el-option>
        </el-select>
        <!-- <el-select v-model="cover" filterable placeholder="请输入关键字">
          <el-option
            v-for="item in countyList"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId"
          >
          </el-option>
        </el-select> -->
        <el-input
          v-model="imgTitle"
          style="width: 220px"
          @keyup.enter.native="searchList"
          placeholder="请输入关键字"
        ></el-input>
      </div>

      <div class="search-right">
        <el-button type="primary" @click="searchList">搜索</el-button>
      </div>
    </div>
    <div v-if="equipList && equipList.length">
      <div class="equip-img-box">
        <div
          class="box-item"
          v-for="(item, index) in equipList"
          :key="index"
          @click="toDetails(item)"
        >
          <div>
            <img :src="item.src" alt="" />
          </div>
          <div>{{ item.coverTitle }}</div>
        </div>
      </div>
      <div class="pagination-box" v-if="total">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
    <div class="empty" v-else>
      <div id="app" class="construction-page">
    <div class="content">
      <h1>模块正在建设中</h1>
      <p>仪器详例模块正在建设中，敬请期待！</p>
    </div>
  </div>
      <!-- <div class="empty-text">
        暂无数据
      </div> -->
      <!--div class="empty-img">
        <img src="@/assets/wenjian.png" alt="" />
      </div-->
    </div>
  </div>
</template>

<script>
import {
  findCheckedEquipPage,
  findGwSubjectList,
  findGradeSectionList,
  findUseRefList,
} from "@/api/equip";
import { getFileById } from "@/api/common";
export default {
  data() {
    return {
      countyList: [],
      dictId: "",
      pageNo: 1,
      pageSize: 15,
      total: null,
      subjectOptions: [],
      subjectList: [],
      gradeSectionOptions: [],
      gradeSectionList: [],
      useRefOptions: [],
      useRefList: [],
      equipList: [],
      imgTitle: "",
      noData: false,
    };
  },
  mounted() {
    this.findGwSubjectList();
    this.findGradeSectionList();
    this.findUseRefList();
    this.findCheckedEquipPage();
  },
  methods: {
    async findCheckedEquipPage() {
      const res = await findCheckedEquipPage({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        subjectIds: this.subjectOptions.join(","),
        sections: this.gradeSectionOptions.join(","),
        uses: this.useRefOptions.join(","),
        imgTitle: this.imgTitle,
      });
      this.equipList = res.data.listData.content;
      this.equipList.forEach((v) => {
        this.getFileById(v);
      });
      this.total = res.data.listData.totalElements;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.findCheckedEquipPage();
    },
    async getFileById(item) {
      const res = await getFileById({
        fileId: item.coverFileId,
        moduleFlag: "equip",
        downFlag: 0,
      });
      const src =
        "data:image/png;base64," +
        btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
      //this.imgBlobBox.push(src);
      this.$set(item, "src", src);
    },
    searchList() {
      console.log("11");
      this.findCheckedEquipPage();
    },
    async findGwSubjectList() {
      const res = await findGwSubjectList();
      this.subjectList = res.data.listData;
    },
    async findGradeSectionList() {
      const res = await findGradeSectionList();
      this.gradeSectionList = res.data.listData;
    },
    async findUseRefList() {
      const res = await findUseRefList();
      this.useRefList = res.data.listData;
    },
    toDetails(item) {
      let routeData = this.$router.resolve({
        path: "/equipDetails",
        query: {
          keyId: item.gwEquipId,
        },
      });
      window.open(routeData.href, '_blank')
    },
  },
};
</script>

<style lang="less" scoped>
.equipList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  .equip-search {
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
  }
  .equip-img-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    .box-item {
      width: 180px;
      margin-right: 60px;
      margin-bottom: 35px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      > div:nth-child(1) {
        width: 100%;
        height: 120px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      > div:nth-child(2) {
        width: 100%;
        height: 26px;
        background: #a30014;
        text-align: center;
        line-height: 26px;
        color: #fff;
      }
    }
  }
  .pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 66px;
  }
}
.empty {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-text {
    margin-top: 50px;
  }
  .empty-img {
    margin-top: 70px;
    > img {
      width: 188px;
      height: 222px;
      object-fit: cover;
    }
  }
}
.construction-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0; /* You can replace this with an image or a more sophisticated design */
}

.content {
  text-align: center;
}

h1 {
  color: #333;
}

p {
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/views/equip/equipList.vue